import React from "react";
import "./Pagenotfound.css";

const Pagenotfound = () => {
    return (
        <>
            <div className="page_container">
                <div className="top">
                    <p>Page Not</p>
                </div>
                <div className="bottom">
                    <p>FOUND</p>
                </div>
            </div>
        </>
    )
}

export default Pagenotfound;